import { User } from '@/modules/backend/Entities/User';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import HomeSmartApi from '@/plugins/HomeSmartApi';
import { CreateUserData } from '@/modules/backend/Dto/CreateUserData';
import { EditUserData } from '@/modules/backend/Dto/EditUserData';

interface State {
  IsLoaded: boolean;
  Users: {
    [userId: number]: User;
  };
}

export const state: State = {
  IsLoaded: false,
  Users: {}
};

export const getters: GetterTree<State, unknown> = {
  Users: (store: State): User[] => Object.values(store.Users).flat(),

  UserById: (store: State) => (userId: number): User | undefined => store.Users[userId],

  IsUsersLoaded: (store: State) => store.IsLoaded
};

export const mutations: MutationTree<State> = {
  Users: (store: State, payload: User[]) => {
    const users = payload.reduce((accum, user: User) => {
      accum[user.getId()] = user;
      return accum;
    }, {} as { [id: number]: User });
    store.Users = { ...store.Users, ...users };
  },

  SetLoaded: (store: State, loaded: boolean) => (store.IsLoaded = loaded),

  Set: (store: State, payload: User) => {
    store.Users = {
      ...store.Users,
      [payload.getId()]: payload
    };
  },

  Unset: (store: State, payload: User) => {
    const users = { ...store.Users };
    delete users[payload.getId()];
    store.Users = users;
  }
};

export const actions: ActionTree<State, unknown> = {
  Fetch: async ({ commit, getters: gtrs }): Promise<void> => {
    if (gtrs.IsUsersLoaded) {
      return gtrs.Users;
    }
    const items: User[] = await HomeSmartApi.Users.Fetch();
    commit('Users', items);
    commit('SetLoaded', true);
  },

  Create: async ({ commit }, payload: CreateUserData): Promise<void> => {
    const user = await HomeSmartApi.Users.Create(payload);
    commit('Set', user);
  },

  Edit: async ({ commit }, payload: EditUserData): Promise<void> => {
    const user = await HomeSmartApi.Users.Edit(payload);
    commit('Set', user);
  },

  Remove: async ({ commit }, payload: User): Promise<void> => {
    await HomeSmartApi.Users.Remove(payload);
    commit('Unset', payload);
  }
};

export const users = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
